import { useQuery } from '@tanstack/react-query';
import 'react';
import { useNotifier } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { Table, Row, ColumnHeading, Cell, Switch } from '@ui/kit';
import { useMatchBreakpoint, FormattedList } from '@utils/react';
import { DeleteTeamAction } from './action.delete-team.js';
import { getTeamsQuery } from './api.get-teams.query.js';
import { useUpdateTeamMutation } from './api.update-team.mutation.js';
import { rowSizingCls, thead, mobileLeftSection, mobileHeadingCell, mobileMetaSection, mobileMetaCell, mobileMetaSeparator } from './atom.table.style.js';
import { makeTeamModalConfig } from './modal.create-team.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function MyTeamsTable() {
  const teams = useQuery(getTeamsQuery.useQueryConfig());
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  return /*#__PURE__*/jsx(Table, {
    thead: /*#__PURE__*/jsxs(Row, {
      as: "header",
      className: thead,
      sizingCls: rowSizingCls,
      children: [/*#__PURE__*/jsx(ColumnHeading, {
        children: "Titel"
      }), /*#__PURE__*/jsx(ColumnHeading, {
        children: "Hold"
      }), /*#__PURE__*/jsx(ColumnHeading, {
        children: "Fag"
      }), /*#__PURE__*/jsx(ColumnHeading, {
        children: "Modtag notifikationer"
      }), !isMobile && /*#__PURE__*/jsx(ColumnHeading, {
        label: "Handlinger"
      })]
    }),
    contentKey: "static",
    items: teams.data ?? [],
    Item: TableItem,
    emptyMessage: /*#__PURE__*/jsxs(Fragment, {
      children: ["Du har ingen hold.", /*#__PURE__*/jsx("br", {}), "Opret de hold du \xF8nsker at modtage besvarelser fra."]
    })
  });
}
function TableItem(props) {
  const notifier = useNotifier();
  const update = useUpdateTeamMutation();
  const isMobile = useMatchBreakpoint(breakpoints.mobile, {
    immediate: true
  });
  const onUpdate = () => {
    if (isMobile) {
      return;
    }
    notifier.modal(makeTeamModalConfig({
      initialTeam: props.item
    }));
  };
  const onToggle = evt => {
    evt.stopPropagation();
    if (update.isPending) {
      return;
    }
    update.mutate({
      ...props.item,
      enabledNotifications: !props.item.enabledNotifications
    });
  };
  return /*#__PURE__*/jsx(Row, {
    onClick: onUpdate,
    sizingCls: rowSizingCls,
    children: isMobile ? /*#__PURE__*/jsx(MobileRowContent, {
      item: props.item,
      onToggle: onToggle
    }) : /*#__PURE__*/jsx(DesktopRowContent, {
      item: props.item,
      onToggle: onToggle
    })
  });
}
function DesktopRowContent(props) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Cell, {
      role: "rowheader",
      children: props.item.title
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(FormattedList, {
        children: props.item.teams
      })
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(FormattedList, {
        children: props.item.subjects
      })
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(Switch, {
        checked: props.item.enabledNotifications,
        onClick: evt => evt.stopPropagation(),
        onChange: props.onToggle,
        "aria-label": props.item.enabledNotifications ? `Slå notifikationer fra for "${props.item.title}"` : `Slå notifikationer til for "${props.item.title}"`
      })
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(DeleteTeamAction, {
        team: props.item
      })
    })]
  });
}
function MobileRowContent(props) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: mobileLeftSection,
      children: [/*#__PURE__*/jsx(Cell, {
        className: mobileHeadingCell,
        role: "rowheader",
        children: props.item.title
      }), /*#__PURE__*/jsxs("div", {
        className: mobileMetaSection,
        children: [/*#__PURE__*/jsx(Cell, {
          className: mobileMetaCell,
          children: /*#__PURE__*/jsx(FormattedList, {
            children: props.item.teams
          })
        }), /*#__PURE__*/jsx("span", {
          className: mobileMetaSeparator,
          children: " - "
        }), /*#__PURE__*/jsx(Cell, {
          className: mobileMetaCell,
          children: /*#__PURE__*/jsx(FormattedList, {
            children: props.item.subjects
          })
        })]
      })]
    }), /*#__PURE__*/jsx(Cell, {
      children: /*#__PURE__*/jsx(Switch, {
        checked: props.item.enabledNotifications,
        onClick: evt => evt.stopPropagation(),
        onChange: props.onToggle
      })
    })]
  });
}

export { MyTeamsTable };
//# sourceMappingURL=atom.table.js.map
